import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { AppLink } from 'lib/app/app-link';
import { CdnImagePath } from 'lib/cdn-image-path';
import LocaleContext from 'lib/locale-context';

import { onClickWhatsNewDateCta } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';

export const ComplimentsBlockFourContainer: FunctionComponent = () => {
  const lang = React.useContext(LocaleContext);

  const imagePath = `${CdnImagePath}/bumble/l-assets/${lang}/features/Compliments-SendBetterCompliments.jpg`;

  const props = {
    imageSrc: imagePath,
    imageAlt: '',
    imageObjectPosition: '65% 10%',
    title: features.compliments.lxComplimentsFourBlockTitle,
    text: features.compliments.lxComplimentsFourBlockBodyText,
    actionText: features.compliments.lxComplimentsFourBlockCta,
    actionUrl: AppLink.BUMBLE_COMPLIMENT_TIPS,
  };

  const bulletPoints = [
    features.compliments.lxComplimentsFourBlockExampleOne,
    features.compliments.lxComplimentsFourBlockExampleTwo,
    features.compliments.lxComplimentsFourBlockExampleThree,
  ];

  return (
    <PageSectionCta
      title={props.title}
      text={props.text}
      action={{
        text: props.actionText,
        href: props.actionUrl,
        onClick: onClickWhatsNewDateCta,
      }}
      image={{
        src: props.imageSrc,
        objectPosition: props.imageObjectPosition,
      }}
      color="orange"
      bulletPoints={bulletPoints}
    />
  );
};
